import { put } from 'redux-saga/effects';
import AuditLogsActions from '../redux/AuditLogsRedux';
import i18n from '../i18n';

export function* getAuditLogs(api, { customerId, params }) {
  try {
    const getAuditLogsResponse = yield api.getAuditLogs(customerId, params);
    if (getAuditLogsResponse.ok) {
      yield put(
        AuditLogsActions.getAuditLogsRequestSuccess(
          getAuditLogsResponse.data.content,
          getAuditLogsResponse.data.totalElements
        )
      );
    } else {
      api.checkAuth(getAuditLogsResponse);
      const error =
        typeof getAuditLogsResponse.problem !== 'undefined'
          ? getAuditLogsResponse.problem
          : typeof getAuditLogsResponse.data.error !== 'undefined'
          ? i18n.t(getAuditLogsResponse.data.error)
          : i18n.t('unexpectedError');
      yield put(AuditLogsActions.getAuditLogsRequestFailure(error));
    }
  } catch (error) {
    console.log('error in AuditLogs saga:', error)
    yield put(AuditLogsActions.getAuditLogsRequestFailure(error));
  }
}